module.exports = __webpack_public_path__ + "img/kommune-1601.f8ed7ba8.svg";